var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getH5GuardFingerprint, getFingerprint } from '@nibfe/mkt-risk-api';
import { getAppVersion } from '@nibfe/mkt-env-api';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { getCityInfo } from '@max/meituan-uni-city';
import { PlatformType, getPlatformType, getSystemType, SystemType, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
const system = getSystemType();
let fpPlatform = 0;
let getCityInfoPromise = getCityInfo();
let APP_TYPE_ENUM = {
    UNKNOWN: 10000,
    MEI_TUAN_APP: 1,
    DIAN_PING_APP: 2
};
let appType = APP_TYPE_ENUM.UNKNOWN;
const cubePlatformType = {
    mtandroid: 6,
    mtiphone: 7,
    dpandroid: 40,
    dpiphone: 41
};
let platformType = getPlatformType();
const isInDPApp = [PlatformType.dpApp, PlatformType.dpAppWebView].indexOf(platformType) > -1;
const isInMTApp = [PlatformType.mtApp, PlatformType.mtAppWebView].indexOf(platformType) > -1;
let cType = 'mtiphone';
if (system === SystemType.android) {
    appType = APP_TYPE_ENUM.MEI_TUAN_APP;
    if (isInMTApp) {
        fpPlatform = cubePlatformType.mtandroid;
        cType = 'mtandroid';
        appType = APP_TYPE_ENUM.MEI_TUAN_APP;
    }
    if (isInDPApp) {
        fpPlatform = cubePlatformType.dpandroid;
        cType = 'dp_android';
        appType = APP_TYPE_ENUM.DIAN_PING_APP;
    }
}
if (system === SystemType.ios || true) {
    if (isInMTApp || true) {
        fpPlatform = cubePlatformType.mtiphone;
        cType = 'mtiphone';
        appType = APP_TYPE_ENUM.MEI_TUAN_APP;
    }
    if (isInDPApp) {
        fpPlatform = cubePlatformType.mtiphone;
        cType = 'dp_iphone';
        appType = APP_TYPE_ENUM.DIAN_PING_APP;
    }
}
export function getAppType() {
    return appType;
}
export function getBuildExtParas() {
    return buildExtParams;
}
function buildExtParams() {
    return __awaiter(this, void 0, void 0, function* () {
        const { gpsLocation = {} } = yield getLBSInfo({
            needLocation: true
        });
        const { lat, lng } = gpsLocation || {};
        const cityInfo = yield getCityInfoPromise;
        const { id } = cityInfo;
        // const [location, cityId, dpCityid] = await Promise.all([
        //     getLocation('pt-97a971e12195aaad'),
        //     getCityId(),
        //     getDpRealCityid()
        // ]).catch((err) => {
        //     addError(
        //         {
        //             name: '获取城市信息经纬度、点评城市id错误',
        //             msg: 'location、cityId、dpCityid错误'
        //         },
        //         {
        //             err
        //         },
        //         'error',
        //         'jsError'
        //     )
        // })
        let h5_fingerprint = '';
        try {
            h5_fingerprint = yield getH5GuardFingerprint();
        }
        catch (e) {
            console.log(e);
        }
        if (!h5_fingerprint) {
            h5_fingerprint = yield getFingerprint();
        }
        const extParams = {
            cTypeForOpt: cType || '',
            actualLatitudeForOpt: Math.round(lat && lat * Math.pow(10, 6) || 0),
            actualLongitudeForOpt: Math.round(lng && lng * Math.pow(10, 6) || 0),
            // actualLatitudeForOpt: 40018802,
            // actualLongitudeForOpt: 116461820,
            fingerAppletsForOpt: '',
            mtFingerprintForOpt: h5_fingerprint || '',
            fpPlatformForOpt: fpPlatform || '',
            dpCityIdForOpt: '',
            mtCityIdForOpt: id,
            supportDynamicMisCouopon: true,
            appVersionForOpt: ''
        };
        try {
            extParams.appVersionForOpt = getAppVersion();
        }
        catch (error) {
            extParams.appVersionForOpt = '';
        }
        if (isInDPApp) {
            extParams.dpCityIdForOpt = id;
        }
        if (isWeixinMiniProgramOrWeixinWebview) {
            extParams.fingerAppletsForOpt = h5_fingerprint || '';
        }
        return extParams;
    });
}
export default buildExtParams;
